// 通用的一些参数
export const scrollerMixin = {
    data() {
        return {
            observer: null,
            loading: false,
            hasMore: true,
            isNotEmpty:true,
            pageNum: 1,
            pageSize: 20,
            rootRef: 'scrollContainer',
            options: {
                root: null, // 指定滚动容器
                rootMargin: '0px',
                threshold: 0.1
            }
        }
    },
    beforeDestroy() {
        this.disconnectObserver();
    },
    methods: {
        disconnectObserver() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
        },

        initObserver({ scrollRequest, rootRef } = {}) {
            // 先断开已有的观察器
            this.disconnectObserver();
            // 确保滚动容器和加载元素存在
            let rootRefTemp = rootRef || this.rootRef
            if (rootRefTemp) {
                if (!this.$refs[rootRefTemp]) {
                    console.error('滚动容器未找到');
                    return;
                }
                this.options.root = this.$refs[rootRefTemp]
            }
            if (!this.$refs.loader) {
                console.error('加载元素未找到');
                return;
            }

            // 配置观察器选项
            console.log('this.options配置=', this.options)
            this.observer = new IntersectionObserver((entries) => {
                console.log('监听视频口的位置=', entries)
                // 正确处理 entries 数组
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.loading && this.hasMore) {
                        // scrollRequest?.()
                        scrollRequest && scrollRequest()
                    }
                });
            }, this.options)

            // 观察加载元素
            this.$nextTick().then(() => {
                this.observer.observe(this.$refs.loader);
                console.log('成功初始化滚动观察器');
            })

        },
    }
}